

const state = {
    transactions: null,
    settings: null,
    details: null,
    transferModalStatus: false,
    transferManager: null,
    transferUserId: null,
    messagesUserId: null,
}

const getters = {
    getMessagesUserId: (state) => {
        return state.messagesUserId
    },
    getTransactions: (state) => {
        return state.transactions
    },
    getSettings: (state) => {
        return state.settings
    },
    getDetails: (state) => {
        return state.details
    },
    getUserTransferModalStatus: (state) => {
        return state.transferModalStatus
    },
    getUserTransferManager: (state) => {
        return state.transferManager
    },
    getUserTransferUserId: (state) => {
        return state.transferUserId
    }
}

const mutations = {
    changeTransactions: (state, newTransactions) => {
        state.transactions = newTransactions
    },
    pushTransaction: (state, newTransaction) => {
        state.transactions.push(newTransaction)
    },
    changeSettings: (state, newSettings) => {
        state.settings = newSettings
    },
    changeDetails: (state, newDetails) => {
        state.details = newDetails
    },
    changeUserTransferModalStatus: (state, newStatus) => {
        return state.transferModalStatus = newStatus
    },
    changeUserTransferManager: (state, newValue) => {
        return state.transferManager = newValue
    },
    changeUserTransferUserId: (state, newValue) => {
        return state.transferUserId = newValue
    },
    changeMessagesUserId: (state, newValue) => {
        return state.messagesUserId = newValue
    }
}

const actions = {
    setTransactions: ({ commit }, newTransactions) => {
        commit('changeTransactions', newTransactions)
    },
    addTransaction: ({ commit }, newTransaction) => {
        commit('pushTransaction', newTransaction)
    },
    setSettings: ({ commit }, newSettings) => {
        commit('changeSettings', newSettings)
    },
    setDetails: ({ commit }, newDetails) => {
        commit('changeDetails', newDetails)
    },
    setUserTransferModalStatus: ({ commit }, newStatus) => {
        commit('changeUserTransferModalStatus', newStatus)
    },
    setUserTransferManager: ({ commit }, newValue) => {
        commit('changeUserTransferManager', newValue)
    },
    setUserTransferUserId: ({ commit }, newValue) => {
        commit('changeUserTransferUserId', newValue)
    },
    setMessagesUserId: ({ commit }, newValue) => {
        commit('changeMessagesUserId', newValue)
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js